import NewProject from "../components/HomePage/new-project";
import HowItWorks from "../components/HomePage/how-it-works";
import StudyResults from "../components/HomePage/study-results";
import FeasibilityStudy from "../components/HomePage/feasibility-study";
import CaseStudies from "../components/HomePage/case-studies";
import ClientsReviews from "../components/HomePage/clients-reviews";
import Subscribe from "../components/HomePage/subscribe";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

const Home = () => {
    return (
      <>
      <Navbar/>
        <div className="home-page">
          <NewProject/>
          <HowItWorks/>
          <StudyResults/>
          <FeasibilityStudy/>
          <CaseStudies/>
          <ClientsReviews/>
          <Subscribe/>
        </div>

        <Footer />
      </>
    );
  };
  
  export default Home;